(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-pli-menu]').forEach(menu => { menu.open = matchMedia('(min-width: 851px)').matches; });
    root.querySelectorAll('[data-pli-products]').forEach(section => {
      const filters = section.querySelector('[data-pli-filters]');
      const cards = [...section.querySelectorAll('[data-pli-intention]')];
      const status = section.querySelector('[data-pli-status]');
      if (filters && cards.length) filters.hidden = false;
      if (status) status.textContent = status.dataset.statusTemplate.replace('[count]', cards.length);
    });
  };
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-pli-filter]');
    if (filter) {
      const section = filter.closest('[data-pli-products]');
      const active = filter.dataset.pliFilter;
      section.querySelectorAll('[data-pli-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      let count = 0;
      section.querySelectorAll('[data-pli-intention]').forEach(card => {
        card.hidden = active !== 'all' && card.dataset.pliIntention !== active;
        if (!card.hidden) count++;
      });
      const status = section.querySelector('[data-pli-status]');
      status.textContent = status.dataset.statusTemplate.replace('[count]', count);
    }
    const link = event.target.closest('[data-pli-menu] a');
    if (link && !matchMedia('(min-width: 851px)').matches) link.closest('[data-pli-menu]').removeAttribute('open');
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-pli-menu][open]').forEach(menu => { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  matchMedia('(min-width: 851px)').addEventListener('change', event => document.querySelectorAll('[data-pli-menu]').forEach(menu => { menu.open = event.matches; }));
  document.addEventListener('shopify:block:select', event => {
    const card = document.querySelector(`[data-pli-block="${event.detail.blockId}"]`);
    if (card) {
      const section = card.closest('[data-pli-products]');
      section.querySelector('[data-pli-filter="all"]')?.click();
    }
  });
  initialize();
})();
